module.exports = __webpack_public_path__ + "resources/img/img_secure_center02_m_jp.e319fad6714df255dc505bf803caa6d6.png";